import { render } from "./app.vue?vue&type=template&id=20c8a3c5&ts=true"
import script from "./app.vue?vue&type=script&lang=ts"
export * from "./app.vue?vue&type=script&lang=ts"

import "./app.vue?vue&type=style&index=0&id=20c8a3c5&lang=css"

import exportComponent from "C:\\src\\BusinessLuchs_CRM\\frontend-dispatcher\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__